module.exports = __webpack_public_path__ + "img/hukusi.57cb63b3.png";